import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface LoaderScreenState {
  visible: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoaderScreenService {
  private readonly defaultMessage = 'Procesando...';
  private readonly stateSubject = new BehaviorSubject<LoaderScreenState>({
    visible: false,
    message: this.defaultMessage,
  });

  readonly state$: Observable<LoaderScreenState> = this.stateSubject.asObservable();

  show(message?: string): void {
    this.stateSubject.next({
      visible: true,
      message: message || this.defaultMessage,
    });
  }

  hide(): void {
    const currentMessage = this.stateSubject.value.message || this.defaultMessage;
    this.stateSubject.next({
      visible: false,
      message: currentMessage,
    });
  }
}
